export default (data) => {
  if (typeof data === 'string') return data;

  // Handle error objects with nested error property
  if (data.error) {
    const { error } = data;
    if (error.message) {
      switch (error.message) {
        default:
          return error.message;
        case 'Failed to fetch':
          return "We can't reach our servers right now, please bear with us.";
      }
    }
    if (error.errorInfo) return data.error.errorInfo.message;
  }

  // Handle timeout errors
  if (data.code === 'TIMEOUT' || data.code === 'ECONNABORTED') {
    return (
      data.message ||
      'Request timed out. Please check your internet connection and try again.'
    );
  }

  // Handle network errors
  if (
    data.code === 'ERR_NETWORK' ||
    data.code === 'NETWORK_ERROR' ||
    data.message === 'Network Error'
  ) {
    return (
      data.message ||
      'Network error. Please check your internet connection and try again.'
    );
  }

  // Handle payment required errors (402)
  if (data.code === 'PAYMENT_REQUIRED' || data.status === 402) {
    return (
      data.message ||
      'Payment processing failed. Please check your payment method and try again, or contact support if the issue persists.'
    );
  }

  // Handle standard error messages
  if (typeof data.message === 'string') return data.message;

  // Fallback for unknown errors
  return 'An error has occured.';
};
